import { motion } from "framer-motion";

/**
 * MaskedLines — signature line-by-line reveal.
 *
 * Each line is wrapped in an overflow-hidden container and rises from below
 * the mask, revealing itself as the mask holds still.
 *
 * Usage:
 *   <MaskedLines lines={["Live", "With", "Vision."]} />
 *   <MaskedLines lines={[...]} delay={0.4} stagger={0.09} />
 */
export default function MaskedLines({
  lines = [],
  delay = 0,
  stagger = 0.09,
  duration = 1.05,
  className = "",
  lineClassName = "",
  as: Tag = "h1",
  ariaLabel,
  once = true,
  whileInView = false,
}) {
  const MotionSpan = motion.span;
  const animateProp = whileInView
    ? { whileInView: { y: "0%" }, viewport: { once, amount: 0.4 } }
    : { animate: { y: "0%" } };

  return (
    <Tag
      className={className}
      aria-label={ariaLabel || lines.join(" ")}
    >
      {lines.map((line, i) => (
        <span
          key={`${line}-${i}`}
          aria-hidden="true"
          className="block overflow-hidden"
        >
          <MotionSpan
            initial={{ y: "105%" }}
            {...animateProp}
            transition={{
              duration,
              delay: delay + i * stagger,
              ease: [0.22, 1, 0.36, 1],
            }}
            className={`block will-change-transform ${lineClassName}`}
          >
            {line}
          </MotionSpan>
        </span>
      ))}
    </Tag>
  );
}
